import React from "react";

export default function Hero() {
  return (
    <header className="hero">
      <div className="hero background" />
      <div className="hero container">
        <h1>MotionView</h1>
      </div>
    </header>
  );
}
